"use strict";
var React = require('react')
var Link = require('react-router')
var LanguageStore = require('../../store/LanguageStore')
 var getAdAction = require('../../actions/getAdAction');
var ListNewsComponent = require('../App/ListNewsComponent');
var Loader = require('react-loader');
var VaznaDokumenta = React.createClass({
  componentDidMount() {
      LanguageStore.addChangeListener(this.onChange);

      var title = this.state.lang !== 'uk' ? 'Important documents | Termovent SC Steal foundry A.D. Bačka Topola' : "Važna dokumenta | Termovent SC Livnica čelika A.D. Bačka Topola"
              document.title = title
    },
    getInitialState() {
        var state = LanguageStore.getLanguage();
        return state;
    },
        componentWillUnmount() {
        LanguageStore.removeChangeListener(this.onChange);
    },
    onChange() {
        var state = LanguageStore.getLanguage();
        this.setState(state);
    },
  render() {
    return (

      <div className='col-margin-top-doc'>
        <div className="col-md-12">
          <ListNewsComponent listType='god_izv' title='VAŽNA DOKUMENTA' limit='false' />
        </div>
      </div>

    )
  }
})

module.exports = VaznaDokumenta;



/** WEBPACK FOOTER **
 ** ./modules/components/VaznaDokumenta/VaznaDokumenta.js
 **/